<template lang="pug">
div(
    @click="clickClose"
    @touchstart="showMenu"
    @mouseenter="showMenu"
    @mouseleave="closeMainMenu"
    v-bind="rootOptions"
)
    //- Category
    slot(:isMenuOpen="isMenuOpen")

    //- Tree or text
    client-only
        template(v-if="wrapperOptions.is")
            transition(name="fade" @after-leave="isMenuActive=false")
                //- isMenuOpen Controls Show/Hide of the total menu
                //- isMenuActive Delays the hiding of children until after Fade Animation
                component(
                    v-show="isMenuOpen"
                    v-bind="wrapperOptions"
                    :data="data"
                    :isActive="isMenuActive"
                )
</template>

<script>
import { bindStoryblokBridgeData } from '../../../helpers'
import TreeMenu from './treeMenu'
import LinkMenu from './linkMenu'
import CmsMenu from './cmsMenu'

export default {
    name: 'NavItem',
    components: { TreeMenu, LinkMenu, CmsMenu },
    props: {
        data: {
            type: Object,
            default() {
                return {}
            },
        },
    },
    data() {
        return {
            isMenuActive: false,
            isMenuOpen: false,
        }
    },
    computed: {
        rootOptions() {
            return bindStoryblokBridgeData(this.data)
        },
        wrapperOptions() {
            const options = {
                is: null,
            }

            switch (this.data.component) {
                case 'tree-menu':
                    if (this.data.items) options.is = TreeMenu
                    break
                case 'link-menu':
                    if (this.data.items) options.is = LinkMenu
                    break
                case 'cms-menu':
                    if (this.data.sections) options.is = CmsMenu
                    break
            }

            return options
        },
    },
    methods: {
        clickClose(event) {
            if (this.$storyblok.isEditing && this.$sitewideData.isNavbarPreview) return
            // Only close the menu if they clicked on a universalLink or it's child
            const elData = event.target.dataset

            if (
                (elData && elData.elementType === 'universalLink') ||
                event.target.closest('[data-element-type="universalLink"]')
            )
                this.closeMainMenu()
        },
        closeMainMenu() {
            clearTimeout(this.navHoverTimer)

            this.isMenuOpen = false
        },
        showMenu() {
            clearTimeout(this.navHoverTimer)

            this.navHoverTimer = setTimeout(() => {
                this.isMenuActive = true
                this.isMenuOpen = true
            }, 175)
        },
    },
}
</script>
